/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LookupClientAliasesResponsePersonasInner } from './LookupClientAliasesResponsePersonasInner';
import {
    LookupClientAliasesResponsePersonasInnerFromJSON,
    LookupClientAliasesResponsePersonasInnerFromJSONTyped,
    LookupClientAliasesResponsePersonasInnerToJSON,
} from './LookupClientAliasesResponsePersonasInner';

/**
 * 
 * @export
 * @interface LookupClientAliasesResponse
 */
export interface LookupClientAliasesResponse {
    /**
     * 
     * @type {Array<LookupClientAliasesResponsePersonasInner>}
     * @memberof LookupClientAliasesResponse
     */
    personas: Array<LookupClientAliasesResponsePersonasInner>;
}

/**
 * Check if a given object implements the LookupClientAliasesResponse interface.
 */
export function instanceOfLookupClientAliasesResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "personas" in value;

    return isInstance;
}

export function LookupClientAliasesResponseFromJSON(json: any): LookupClientAliasesResponse {
    return LookupClientAliasesResponseFromJSONTyped(json, false);
}

export function LookupClientAliasesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LookupClientAliasesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'personas': ((json['personas'] as Array<any>).map(LookupClientAliasesResponsePersonasInnerFromJSON)),
    };
}

export function LookupClientAliasesResponseToJSON(value?: LookupClientAliasesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'personas': ((value.personas as Array<any>).map(LookupClientAliasesResponsePersonasInnerToJSON)),
    };
}

